export default "__VITE_ASSET__BTRNwR2Z__"